import React from "react";
import { FormGroup, Modal, ModalBody, ModalFooter } from "reactstrap";
import SpinnerButton from "../../../components/Button";

function ConfirmInactiveSubclient({ toggle, handleSubmit, isLoading }) {
  return (
    <Modal centered backdrop="static" isOpen toggle={toggle}>
      <FormGroup>
        <ModalBody toggle={toggle} style={{ fontSize: "20px", cursor: "pointer" }}>
          ¿Confirma que desea desactivar el subcliente? <b>Una vez inactivo dejará de mostrarse en la lista </b>
        </ModalBody>
        <ModalFooter>
          <div className="mb-0 px-3 w-100 d-flex justify-content-between">
            <SpinnerButton className="btn btn-light" type="button" onClick={toggle}>
              Cancelar
            </SpinnerButton>
            <SpinnerButton isLoading={isLoading} className="btn btn-primary" type="button" onClick={handleSubmit}>
              Confirmar
            </SpinnerButton>
          </div>
        </ModalFooter>
      </FormGroup>
    </Modal>
  );
}

export default ConfirmInactiveSubclient;
